//@ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchAuthorizedUserOptions, updateAuthorizedUser } from '../api';
import {
  authorizedUserOptionsFetched,
  authorizedUserOptionsFetchFailed,
  authorizedUserOptions,
  updateAuthorizedUserFetched,
  updateAuthorizedUserFetchFailed,
  authorizedUserOptionsRequest,
  updateAuthorizedUserRequest,
} from '../reducer/supplemeantrySlice';

export function* fetchAuthorizedUserOptionsSaga(action) {
  try {
    const { accountId, customerId } = action.payload;
    console.log('fetchAuthorizedUserOptionsSaga');
    const response = yield call(
      fetchAuthorizedUserOptions,
      'authorized_user_options',
      accountId,
      customerId
    );
    console.log('fetchAuthorizedUserOptionsSaga after =', response);
    if (response.assignmentId) {
      yield put(authorizedUserOptionsFetched(response));
    } else {
      yield put(authorizedUserOptionsFetchFailed(response));
    }
  } catch (error: any) {
    yield put(
      authorizedUserOptionsFetchFailed(error.message || 'Something went wrong')
    );
  }
}

export function* updateAuthorizedUserSaga(action) {
  try {
    const { accountId, customerId, requestBody } = action.payload;
    const response = yield call(
      updateAuthorizedUser,
      'authorized_user',
      accountId,
      customerId,
      requestBody
    );
    if (response?.status === 'APPROVED') {
      yield put(updateAuthorizedUserFetched(response));
    } else {
      yield put(updateAuthorizedUserFetchFailed(response));
    }
  } catch (error: any) {
    yield put(
      updateAuthorizedUserFetchFailed(error.message || 'Something went wrong')
    );
  }
}

// Watch sagas
export function* watchSupplemeantrySagas(): Generator<any, void, unknown> {
  yield takeLatest(
    authorizedUserOptionsRequest.type,
    fetchAuthorizedUserOptionsSaga
  );
  yield takeLatest(updateAuthorizedUserRequest.type, updateAuthorizedUserSaga);
}
